<template>
    <div class="page">
        <div class="header">
            <img src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/01/08/9cc7f0f4ac4b43b7a42b67eafb53f254.png"
                @click="$router.replace('/')">
            <div class="navbar">
                <div :class="['navbarItem']" v-for="(item, index) in navbar" :key="index"
                    @click="navbarChange(item, index)">
                    {{ item.name }}
                    <div class="active" v-if="navIndex == index"></div>
                </div>
            </div>
            <div style="flex: 1;"></div>
            <el-dropdown trigger="click">
                <span style="cursor: pointer;font-size: 16px;">
                    <i class="el-icon-user"></i> 管理员
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <div @click="getOut()">
                            退出登录
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="main">
            <Product v-if="navIndex == 0"></Product>
            <Classify v-if="navIndex == 1"></Classify>
            <Brand v-if="navIndex == 2"></Brand>
            <Carousel v-if="navIndex == 3"></Carousel>
            <Message v-if="navIndex == 4"></Message>
        </div>
    </div>
</template>
<script>
import Product from '@/components/Product.vue';
import Classify from '@/components/Classify.vue';
import Brand from '@/components/Brand.vue';
import Carousel from '@/components/Carousel.vue';
import Message from '@/components/Message.vue';
export default {
    components: {
        Product,
        Classify,
        Brand,
        Carousel,
        Message,
    },
    data() {
        return {
            navIndex: 0,
            navbar: [
                { name: '产品管理' },
                { name: '产品分类' },
                { name: '代理品牌' },
                { name: '轮播图' },
                { name: '客户留言' }
            ],
        }
    },
    mounted() {

    },
    methods: {
        getOut() {
            localStorage.removeItem('token')
            this.$message({
                duration: 1500,
                type: 'success',
                message: '退出登录成功'
            });
            setTimeout(() => {
                this.$router.replace({
                    path: '/login'
                })
            })
        },
        navbarChange(item, index) {
            if (this.navIndex == index) {
                return
            }
            this.navIndex = index
        },

    }
}
</script>
<style scoped lang="less">
.page {
    width: 100%;
    box-sizing: border-box;
    word-break: break-all;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .main {
        width: 100%;
        height: calc(100vh - 64px);
    }

    .header {
        background-color: #fff;
        width: 100%;
        height: 64px;
        padding: 0 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .username {
            cursor: pointer;
            font-size: 20px;
            color: #1f2939;
        }

        img {
            height: 70%;
            margin-right: 20px;
            cursor: pointer;
        }

        .navbar {
            display: flex;



            .navbarItem {
                font-size: 16px;
                color: #1f2939;
                cursor: pointer;
                font-weight: 500;
                padding: 0 15px;
                line-height: 64px;
                box-sizing: border-box;
                position: relative;

                .active {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 15px;
                    background-color: #2769b4;
                    height: 2.5px;
                    width: 55%;
                }
            }
        }
    }
}
</style>